import React from "react";
import "./Loader.css";

const Loader = () => {
  return (
    <div className="loader-container">
      <div className="spinner-ring"></div>
      <div className="loader-brand">Credible Investment Experts</div>
    </div>
  );
};

export default Loader;
